<template>
  <v-layout
      row
      :style="maxWidth"
  >
    <v-flex
        class="ml-3"
        :style="maxWidth"
    >
            <breadcrumbs
                :items="breadcrumbsItems"
            ></breadcrumbs>
      <v-card
          class="ma-3 col-sm-6" outlined
      >
            <v-card-title>Create Blacklist</v-card-title>
            <hr class="ma-1">
            <div class="col">
                <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation
                >
                    <v-text-field
                        v-model="phone_no"
                        label="Phone No."
                        hint="6588888888"
                    ></v-text-field>

                    <v-text-field
                        v-model="remarks"
                        label="Remarks"
                    ></v-text-field>

                    <v-btn
                        :disabled="!valid"
                        color="success"
                        class="mr-4 font-weight-bold"
                        @click="submit"
                    >
                        Save
                    </v-btn>
                </v-form>
            </div>
        </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from 'axios'

export default {
    data: () => ({
        valid: true,
        phone_no: '',
        remarks: '',
        breadcrumbsItems: '',
    }),
    props: ['group', 'outlet'],
  computed: {
    maxWidth() {
      return {
        maxWidth: window.outerWidth + 'px'
      }
    }
  },
    methods: {
        submit() {
            let group = this.group;
            let outlet = this.outlet;
            if (this.$refs.form.validate()) {
                axios.post('/group/' + this.group.id + '/blacklist', {
                    phone_no: this.phone_no,
                    remarks: this.remarks,
                    group_id: this.group.id
                }).then(function (result) {
                    window.location.href = '/outlet/' + outlet.id + '/edit';
                });
            }
        }
    },
    beforeMount() {
        this.breadcrumbsItems = [
            {
                disabled: false,
                href: '/',
                link: true,
                text: 'Home',
            },
            {
                disabled: false,
                href: '/outlet/' + this.outlet.id + '/edit',
                link: true,
                text: this.outlet.name,
            },
            {
                disabled: true,
                href: '#',
                link: true,
                text: 'Create Blacklist',
            },
        ];
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Blacklist/BlacklistCreate.vue